module.exports = __webpack_public_path__ + "img/facebook-profile-instruction-2.ce173927.png";